<template>
    <div class="facebook-sync-setting">
        <div class="text-container">
            <FeatherIcon name="refresh-cw" />
            <div v-if="setup" class="text">
                <div class="copy-m bold">{{ $t('venue.facebook_sync.headline') }}</div>
            </div>
            <div v-if="!setup" class="text">
                <div class="copy-m bold">{{ $t('venue.facebook_sync.headline') }}</div>
                <div class="copy-s">{{ $t('venue.facebook_sync.description') }}</div>
            </div>
        </div>
        <LargeSwitch v-if="!setup" :active="switchstate" @toggle="switchstate = !switchstate"></LargeSwitch>
        <Button v-if="setup" type="dark-secondary" :value="$t('venue.facebook_sync.button')" round />
    </div>
</template>

<script>
import LargeSwitch from '@/components/LargeSwitch'
import FeatherIcon from '@/components/FeatherIcon'
import Button from '@/components/Button'
export default {
    name: 'FacebookSyncSetting',
    components: {
        LargeSwitch,
        FeatherIcon,
        Button,
    },
    props: {
        setup: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            switchstate: true,
        }
    },
}
</script>

<style scoped lang="sass">

.facebook-sync-setting
    background: $neutral-black
    border-radius: 12px
    height: 70px
    padding: 0 $l
    display: flex
    align-items: center
    justify-content: space-between

    &:hover
        .feather-icon
            transform: rotate(180deg)
            +transition(200ms)

    .text-container
        display: flex
        align-items: center

        .copy-m
            color: white

        .copy-s
            color: $neutral-1

        .feather-icon
            margin-right: $m

            &::v-deep
                svg
                    stroke: white


    //
</style>
